import useAuthenticatedFetch from "@/hooks/useAuthenticatedFetch.ts";
import { apiUrl } from "@/utils/api.ts";
import { type UseMutationResult, useMutation, useQueryClient } from "@tanstack/react-query";
import { handleJsonApiError } from "jsonapi-zod-query";

export const useDeleteNotification = (): UseMutationResult<
    void,
    Error,
    { notificationUUID: string; noteId?: string }
> => {
    const fetch = useAuthenticatedFetch();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({ notificationUUID }) => {
            const response = await fetch(apiUrl("/notification/delete"), {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/vnd.api+json",
                },
                body: JSON.stringify({
                    notificationUUID: notificationUUID,
                }),
            });
            await handleJsonApiError(response);
        },
        onSuccess: async (_, variables) => {
            await queryClient.invalidateQueries({
                queryKey: ["case-notifications"],
            });
            await queryClient.invalidateQueries({
                queryKey: ["notification-history"],
            });
            if (variables.noteId) {
                await queryClient.invalidateQueries({
                    queryKey: ["note-details", variables.noteId],
                });
            } else {
                // Clear all note-details cache if no specific noteId (e.g., "Mark All as Read")
                await queryClient.invalidateQueries({
                    queryKey: ["note-details"],
                });
            }
        },
    });
};
